__turbopack_context__.v({
  "container": "NewsHeroFeatured-module-scss-module__1jOvNq__container",
  "loader": "NewsHeroFeatured-module-scss-module__1jOvNq__loader",
  "mainCard": "NewsHeroFeatured-module-scss-module__1jOvNq__mainCard",
  "mainContent": "NewsHeroFeatured-module-scss-module__1jOvNq__mainContent",
  "mainImage": "NewsHeroFeatured-module-scss-module__1jOvNq__mainImage",
  "mainImageContent": "NewsHeroFeatured-module-scss-module__1jOvNq__mainImageContent",
  "mainTitle": "NewsHeroFeatured-module-scss-module__1jOvNq__mainTitle",
  "metaRow": "NewsHeroFeatured-module-scss-module__1jOvNq__metaRow",
  "root": "NewsHeroFeatured-module-scss-module__1jOvNq__root",
  "sideArticle": "NewsHeroFeatured-module-scss-module__1jOvNq__sideArticle",
  "sideColumn": "NewsHeroFeatured-module-scss-module__1jOvNq__sideColumn",
  "sideContent": "NewsHeroFeatured-module-scss-module__1jOvNq__sideContent",
  "sideImage": "NewsHeroFeatured-module-scss-module__1jOvNq__sideImage",
  "sideImageContent": "NewsHeroFeatured-module-scss-module__1jOvNq__sideImageContent",
  "sideTitle": "NewsHeroFeatured-module-scss-module__1jOvNq__sideTitle",
  "time": "NewsHeroFeatured-module-scss-module__1jOvNq__time",
});
